import useHome from "hooks/useHome";
import HomeIntro from "components/HomeIntro";
import HomeMapView from "components/HomeMapView";
import HomeEquipments from "components/HomeEquipments";
import HomePriceOverview from "components/HomePriceOverview";
import HomeAvailabilityCalendar from "components/HomeAvailabilityCalendar";
import HomeCheckout from "components/HomeCheckout";
import HomeRemarks from "components/HomeRemarks";
import HomeDateRangeSelect from "components/HomeDateRangeSelect";
import HomeImageGallery from "components/HomeImageGallery";
import DetailPagetLayout from "components/Layout";
import HomePackageList from "components/HomePackageList";

export default function HomePage() {
  const { venue, priceList } = useHome();

  return (
    <div className="nc-ListingStayDetailPage">
      <DetailPagetLayout>
        {venue ? (
          <>
            <header className="rounded-md sm:rounded-xl">
              <HomeImageGallery />
            </header>
            <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
              <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
                <HomeIntro venue={venue} />
                <HomeAvailabilityCalendar />
                <HomePackageList />
                <HomeEquipments venue={venue} />
                <HomeMapView venue={venue} />
                <HomePriceOverview priceList={priceList} />
                {/* <HomeDateRangeSelect /> */}
                <HomeRemarks venue={venue} />
              </div>
              <HomeCheckout />
            </main>
          </>
        ) : (
          <></>
        )}
      </DetailPagetLayout>
    </div>
  );
}
